import React from 'react';
import DownloadIcon from 'src/common/utils/TableColumnIcons/DownloadIcon';

export const ActionResolutionDownload = (value, row, rowIndex, { onDownload }) => {
	return (
		<>
			{value === undefined ? (
				<></>
			) : (
				<DownloadIcon
					tooltip={value.nombre}
					onClick={() => onDownload(value)}
					color="#808080"
				/>
			)}
		</>
	);
};
